import React, { SVGProps } from 'react';

const IconIdeal = (props: SVGProps<SVGSVGElement>) => (
  <svg width="34" height="34" viewBox="0 0 34 34" fill="none" {...props}>
    <path
      d="M0 4.2215V29.7465C0 30.9683 0.999673 31.968 2.2215 31.968H17.4721C29.0016 31.968 34 25.5145 34 16.9507C34 8.43123 29.0016 2 17.4721 2H2.2215C0.999673 2 0 2.99967 0 4.2215Z"
      fill="white"
    />
    <path
      d="M10.2078 8.26462V27.1251H18.4162C25.8693 27.1251 29.1016 22.9154 29.1016 16.9618C29.1016 11.2636 25.8693 6.84286 18.4162 6.84286H11.6295C10.8409 6.84286 10.2078 7.4871 10.2078 8.26462Z"
      fill="#CC0066"
    />
    <path
      d="M17.4721 29.9353H4.20972C3.03233 29.9353 2.07709 28.9801 2.07709 27.8027V6.1764C2.07709 4.99901 3.03233 4.04376 4.20972 4.04376H17.4721C30.0568 4.04376 31.934 12.1411 31.934 16.9618C31.934 25.3257 26.7912 29.9353 17.4721 29.9353ZM4.20972 4.75464C3.42109 4.75464 2.78797 5.38777 2.78797 6.1764V27.8027C2.78797 28.5913 3.42109 29.2244 4.20972 29.2244H17.4721C26.3358 29.2244 31.2231 24.8703 31.2231 16.9618C31.2231 6.34301 22.6037 4.75464 17.4721 4.75464H4.20972Z"
      fill="black"
    />
    <path
      d="M13.0957 14.4182C13.3845 14.4182 13.6511 14.4626 13.9066 14.5514C14.162 14.6403 14.3731 14.7847 14.5619 14.9624C14.7396 15.1512 14.884 15.3845 14.9951 15.6511C15.0951 15.9288 15.1506 16.2509 15.1506 16.6285C15.1506 16.9618 15.1062 17.2617 15.0284 17.5394C14.9396 17.817 14.8174 18.0614 14.6508 18.2613C14.4842 18.4613 14.2731 18.6168 14.0176 18.739C13.7622 18.85 13.4623 18.9167 13.1179 18.9167H11.1741V14.407H13.0957V14.4182ZM13.0291 18.0947C13.1735 18.0947 13.3068 18.0725 13.4512 18.0281C13.5845 17.9837 13.7066 17.9059 13.8066 17.7948C13.9066 17.6838 13.9954 17.5505 14.0621 17.3727C14.1287 17.195 14.162 16.9951 14.162 16.7396C14.162 16.5175 14.1398 16.3064 14.0954 16.1287C14.051 15.951 13.9732 15.7844 13.8733 15.6622C13.7733 15.54 13.64 15.4289 13.4734 15.3623C13.3068 15.2956 13.1068 15.2623 12.8625 15.2623H12.1516V18.1058H13.0291V18.0947Z"
      fill="white"
    />
    <path
      d="M19.1604 14.4182V15.2512H16.7834V16.2176H18.9716V16.984H16.7834V18.0836H19.2159V18.9167H15.7948V14.407H19.1604V14.4182Z"
      fill="white"
    />
    <path
      d="M22.5593 14.4182L24.2477 18.9278H23.2147L22.8703 17.9281H21.182L20.8265 18.9278H19.8269L21.5263 14.4182H22.5593ZM22.6149 17.1839L22.0484 15.5289H22.0373L21.4486 17.1839H22.6149Z"
      fill="white"
    />
    <path d="M25.8582 14.4182V18.0947H28.0575V18.9278H24.8697V14.4182H25.8582Z" fill="white" />
    <path
      d="M6.49788 18.7501C7.64503 18.7501 8.57497 17.8201 8.57497 16.673C8.57497 15.5258 7.64503 14.5959 6.49788 14.5959C5.35073 14.5959 4.42078 15.5258 4.42078 16.673C4.42078 17.8201 5.35073 18.7501 6.49788 18.7501Z"
      fill="black"
    />
    <path
      d="M8.06404 27.1251C6.32017 27.1251 4.92062 25.7145 4.92062 23.9817V21.5269C4.92062 20.6606 5.6204 19.9497 6.49789 19.9497C7.36427 19.9497 8.07515 20.6494 8.07515 21.5269V27.1251H8.06404Z"
      fill="black"
    />
  </svg>
);

export default IconIdeal;
